// @flow

import stickybits from "stickybits";

export default function positionStickyFallback(element: Element) {
    // If browser doesn't support position sticky, import stickybits as a fallback
    if (!window.CSS.supports("position", "sticky")) {
        stickybits(element, {
            useFixed: true,
            noStyles: false,
        });
    }
}
